import { ExportFileButton } from 'components/buttons';

import { useReportDownload } from '../_hooks/useReportDownload';

import { useSearchCriterion } from '@cast/shared-search-ui';

type ExportCsvButtonProps = {
  clusterIds?: string[];
};

export const ExportCsvButton = ({ clusterIds }: ExportCsvButtonProps = {}) => {
  const { value: selectedStandard } = useSearchCriterion('standard');
  const {
    download,
    isLoading: isLoadingCsvData,
    hasError: csvDataHasError,
  } = useReportDownload({ standard: selectedStandard, clusterIds });

  return (
    <ExportFileButton
      onClick={download}
      testId="download-csv-report"
      disabled={isLoadingCsvData || csvDataHasError}
    />
  );
};
